module.exports = __webpack_public_path__ + "img/k.dd6c8e50.jpg";